import PrebuiltAccaImpl from './prebuilt-acca.js';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';

const UIView = MojitoCore.Presentation.UIView;

/**
 * PrebuiltAcca view that renders prebuilt acca card.
 *
 * @class PrebuiltAcca
 * @memberof Mojito.Modules
 */

/**
 * Prebuilt bet prop types.
 *
 * @property {object} event - ID to populate data with (top leagues or all leagues).
 * @property {object} market - ID to populate data with (top leagues or all leagues).
 * @property {string|undefined} [promotionText] - Promotion text to be displayed on the card.
 * @property {Function} [onEventClick] - Callback to get state of child element loading.
 *
 * @memberof Mojito.Modules.PrebuiltAcca
 */
const propTypes = {
    event: PropTypes.object.isRequired,
    market: PropTypes.object.isRequired,
    promotionText: PropTypes.string,
    onEventClick: PropTypes.func,
};

export default UIView('PrebuiltAcca', PrebuiltAccaImpl, propTypes);
